import { useState, useCallback } from 'react';
import { Gallery } from '../api/types';
import { PhotoStreamClient } from '../api/PhotoStreamClient';

interface UseGalleryReturn {
  gallery: Gallery | null;
  loading: boolean;
  error: string | null;
  loadGallery: (galleryId: string) => Promise<void>;
}

export const useGallery = (apiClient: PhotoStreamClient): UseGalleryReturn => {
  const [gallery, setGallery] = useState<Gallery | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const loadGallery = useCallback(async (galleryId: string) => {
    try {
      setLoading(true);
      setError(null);
      const galleryData = await apiClient.getGallery(galleryId);
      setGallery(galleryData);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load gallery');
    } finally {
      setLoading(false);
    }
  }, [apiClient]);

  return {
    gallery,
    loading,
    error,
    loadGallery,
  };
};
